const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Nome repetido!',
    nameIsEmpty: 'O nome está vazio!',
    notificationPreference: 'Selecione as unidades e as configurações de preferência de notificação correspondentes',
    option1: 'Quero receber notificações recomendadas da Enphase para todas as unidades',
    option2: 'Eu quero personalizar minhas notificações',
    pageHeader: 'Preferências',
    title: 'Selecione uma opção para notificações',
    saveDialogHeader: 'Salvar alterações?',
    saveConfirmText: 'Quer salvar as alterações feitas?',
    cancelButton: 'Descartar',
    saveButton: 'Salve',
    defaultDeselectWarning: 'Nota: você não pode remover unidades do conjunto de preferências padrão',
    displayPreferences: 'Preferências de exibição',
    ownSites: 'Unidades próprias',
    otherSites: 'Outras unidades',
    emptySites: 'Nenhuma unidade disponível!',
    emptyPreferenceSet: 'Sem preferências!',
    preference: 'Preferência',
    actions: 'Ações',
    settingsInfo: 'Essas configurações são aplicáveis apenas para unidades do Ensemble',
    selectType: 'Conjuntos de preferências',
    selectSite: 'Seleção de unidade',
    selectSettings: 'Configurações de preferência de notificação',
    addText: 'Adicionar',
    deleteAlertHeader: 'Confirmar exclusão',
    deleteAlertDescription: 'Tem certeza de que deseja remover permanentemente esta preferência?',
    deleteAlertCancel: 'Cancelar',
    deleteAlertConfirm: 'Ok',
    siteEditWarning:
      'Todas as outras unidades são definidas como "Preferência padrão”, como Preferências de notificação deles',
    defaultOwnInfo: 'Todas as unidades compradas são definidas como "Preferência padrão - comprada"',
    defaultOtherInfo: 'Todas as outras unidades são definidas como "Preferência padrão - outras"',
    defaultInfo: 'Todos as unidades estão definidas como "Preferência padrão"',
    createNew: 'Adicionar nova preferência',
    siteEditWarningMinimal:
      'Todas as outras unidades são definidas como "Preferência padrão”, como Preferências de notificação deles',
    selectAll: 'Selecionar tudo',
    generalNotification: 'Notificações gerais',
    switchToNewPreferencePage: 'MUDAR PARA A PÁGINA DE PREFERÊNCIAS NOVA'
  },
  preferences: {
    pageHeader: 'Preferências',
    title: 'Configurações de preferências',
    notificationPreference: 'Preferências de notificação',
    activationNotification: 'Envie-me notificações de ativação.',
    monthlySummary: 'Envie-me resumos mensais de desempenho do sistema.',
    newsletters: 'Envie-me boletins informativos, promoções e pesquisas sobre os produtos ou serviços da Enphase.',
    newLeadsNotification: 'Notifique-me sobre novos leads e alterações de status',
    alertEmail: 'PREFERÊNCIA DE E-MAIL DE ALERTA',
    deviceEventsEmail:
      'Envie-me um e-mail sobre eventos no nível do dispositivo (selecione o nível de impacto abaixo):',
    exceptionsAlertEmail: 'Você pode especificar exceções para sua preferência de e-mail de alerta por sistema.',
    alertPreferences: 'Veja as preferências de alerta por sistema',
    saveNotificationPreferences: 'SALVAR PREFERÊNCIAS DE NOTIFICAÇÃO',
    displayPreferences: 'Preferências de exibição',
    displayUnits: 'Unidades de exibição',
    metric: 'Métricas',
    imperial: 'Imperiais',
    saveDisplayPreferences: 'SALVAR PREFERÊNCIAS DE EXIBIÇÃO',
    systemAlert: 'Preferência de alerta do sistema: ',
    saveChanges: 'Salvar alterações',
    label: 'Envie-me um e-mail sobre eventos no nível do dispositivo (selecione o nível de impacto abaixo): ',
    alertEmailPreference: 'Preferência de e-mail de Alerta',
    systems: 'Sistemas'
  }
};

export default preferences;
